import { render, staticRenderFns } from "./TipsPercents.vue?vue&type=template&id=9f481ba4&scoped=true&"
import script from "./TipsPercents.vue?vue&type=script&setup=true&lang=ts&"
export * from "./TipsPercents.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./TipsPercents.vue?vue&type=style&index=0&id=9f481ba4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f481ba4",
  null
  
)

export default component.exports